/**
 * ItoMark — the Ito Research logo as an inline, theme-aware SVG.
 *
 * This is the same mark used in `public/favicon.svg` (a chevron/"A" glyph in a
 * rounded square), but drawn with design tokens instead of hard-coded colors so
 * it inverts correctly in every theme. Used as the menu-bar home affordance.
 */

import { cn } from "@itoresearch/design-system";

export function ItoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      role="img"
      aria-label="Ito Research"
      className={cn("shrink-0", className)}
    >
      <rect width="32" height="32" rx="7" fill="var(--foreground)" />
      <path
        d="M9 22 16 9l7 13h-3.4L16 14.4 12.4 22z"
        fill="var(--background)"
      />
    </svg>
  );
}
